import { useMemo } from 'react'
import type { HelpdeskDashboardStats } from '@/lib/services/helpdeskDashboardService'
import ReportLineChart from '@/components/reports/ReportLineChart'

const SERIES = [
  { dataKey: 'Today', name: 'Today', color: '#3182CE' },
  { dataKey: 'Yesterday', name: 'Yesterday', color: '#90CDF4' },
]

type Props = {
  stats: HelpdeskDashboardStats
  loading?: boolean
}

export default function TrendsCard({ stats, loading }: Props) {
  const data = useMemo(() => {
    if (stats.trends_today.length !== 24) return []
    return Array.from({ length: 24 }, (_, i) => ({
      name: `${i}:00`,
      Today: stats.trends_today[i] ?? 0,
      Yesterday: stats.trends_yesterday[i] ?? 0,
    }))
  }, [stats.trends_today, stats.trends_yesterday])

  return (
    <ReportLineChart
      title="Today's trends"
      subtitle="Created date — hour of the day"
      data={data}
      xKey="name"
      series={SERIES}
      loading={loading}
      height={200}
      emptyMessage="No hourly trend data available."
    />
  )
}
